module.exports = __webpack_public_path__ + "media/images/3_clevas_complete_inactive-267c0e0d.png";